document.addEventListener('DOMContentLoaded', function () {
  const popup = document.getElementById('book-popup');

  if(!popup) return

  const closeBtn = document.getElementById('close-book-popup');
  const form = document.getElementById('book-popup-form');
  const prevBtn = document.getElementById('book-popup-prev');
  const nextBtn = document.getElementById('book-popup-next');
  const monthLabel = document.getElementById('book-popup-month-label');
  const datesGrid = document.getElementById('book-popup-dates');
  const datesBody = datesGrid.querySelector('tbody');
  const checkinLabel = document.getElementById('book-popup-checkin-label');
  const checkoutLabel = document.getElementById('book-popup-checkout-label');
  const checkinInput = document.getElementById('book-popup-checkin-input');
  const checkoutInput = document.getElementById('book-popup-checkout-input');

  const MONTHS = ['January','February','March','April','May','June','July','August','September','October','November','December'];
  const DAYS = ['Sunday','Monday','Tuesday','Wednesday','Thursday','Friday','Saturday'];

  let today = new Date();
  today.setHours(0, 0, 0, 0);

  const seasonStartStr = form.dataset.seasonStart || '';
  let seasonStart = null;
  if (seasonStartStr) {
    const parts = seasonStartStr.split('-'); // ['YYYY','MM','DD']
    if (parts.length === 3) {
      const candidate = new Date(parseInt(parts[0], 10), parseInt(parts[1], 10) - 1, parseInt(parts[2], 10));
      candidate.setHours(0, 0, 0, 0);
      if (candidate > today) seasonStart = candidate;
    }
  }

  const effectiveMin = seasonStart || today;
  let viewYear = effectiveMin.getFullYear();
  let viewMonth = effectiveMin.getMonth();
  let checkin = null;
  let checkout = null;
  let lastOpener = null;

  function getOpeners() {
    return document.querySelectorAll('a[href="#book-popup"]');
  }

  function formatDate(d) {
    return (d.getMonth() + 1) + '/' + d.getDate() + '/' + d.getFullYear();
  }

  function iso(d) {
    return d.getFullYear() + '-' + String(d.getMonth() + 1).padStart(2, '0') + '-' + String(d.getDate()).padStart(2, '0');
  }

  function fromIso(s) {
    const p = s.split('-').map(Number);
    return new Date(p[0], p[1] - 1, p[2]);
  }

  function sameDay(a, b) {
    return a && b && a.getTime() === b.getTime();
  }

  function isBeforeMinMonth(date) {
    return new Date(date.getFullYear(), date.getMonth(), 1) < new Date(effectiveMin.getFullYear(), effectiveMin.getMonth(), 1);
  }

  function renderCalendar() {
    monthLabel.textContent = MONTHS[viewMonth] + ' ' + viewYear;
    prevBtn.disabled = viewYear === effectiveMin.getFullYear() && viewMonth === effectiveMin.getMonth();
    datesBody.innerHTML = '';

    const startDay = new Date(viewYear, viewMonth, 1).getDay();
    const daysInMonth = new Date(viewYear, viewMonth + 1, 0).getDate();

    const cells = [];
    for (let i = 0; i < startDay; i++) cells.push(null);
    for (let d = 1; d <= daysInMonth; d++) cells.push(d);
    while (cells.length % 7) cells.push(null);

    let row;
    cells.forEach(function (d, i) {
      if (i % 7 === 0) {
        row = document.createElement('tr');
        datesBody.appendChild(row);
      }
      const cell = document.createElement('td');
      row.appendChild(cell);
      if (d === null) {
        cell.setAttribute('aria-hidden', 'true');
        return;
      }

      // Reviewer-specified markup: <td data-date><button aria-selected aria-label>26</button></td>
      // Every available day is a native button in the Tab order (NVDA browse mode friendly).
      const date = new Date(viewYear, viewMonth, d);
      cell.dataset.date = iso(date);
      const btn = document.createElement('button');
      btn.type = 'button';
      btn.textContent = d;
      cell.appendChild(btn);
      let label = DAYS[date.getDay()] + ', ' + MONTHS[viewMonth] + ' ' + d + ', ' + viewYear;

      if (date < effectiveMin) {
        btn.classList.add('past');
        btn.setAttribute('aria-disabled', 'true');
        btn.setAttribute('tabindex', '-1'); // skipped by Tab, still reachable with arrows
        label += ', unavailable';
      } else {
        const isCheckin = sameDay(date, checkin);
        const isCheckout = sameDay(date, checkout);
        if (isCheckin) {
          btn.classList.add('checkin');
          label += ' (check-in)';
        }
        if (isCheckout) {
          btn.classList.add('checkout');
          label += ' (check-out)';
        }
        btn.setAttribute('aria-selected', isCheckin || isCheckout ? 'true' : 'false');
        if (checkin && checkout && date > checkin && date < checkout) {
          btn.classList.add('in-range');
        }
      }

      btn.setAttribute('aria-label', label);
    });
  }

  function updateLabels() {
    checkinLabel.textContent = 'Check-in: ' + (checkin ? formatDate(checkin) : '—');
    checkoutLabel.textContent = 'Check-out: ' + (checkout ? formatDate(checkout) : '—');
  }

  function selectDate(date) {
    if (!checkin || checkout) {
      checkin = date;
      checkout = null;
    } else if (date <= checkin) {
      checkin = date;
      checkout = null;
    } else {
      checkout = date;
    }
    updateLabels();
    checkinInput.value = checkin ? formatDate(checkin) : '';
    checkoutInput.value = checkout ? formatDate(checkout) : '';
    renderCalendar();
    focusDate(date);
  }

  // Move focus to a date, switching the visible month when needed (APG date picker pattern).
  function focusDate(date) {
    if (isBeforeMinMonth(date)) return;
    if (date.getFullYear() !== viewYear || date.getMonth() !== viewMonth) {
      viewYear = date.getFullYear();
      viewMonth = date.getMonth();
      renderCalendar();
    }
    const btn = datesBody.querySelector('td[data-date="' + iso(date) + '"] button');
    if (btn) btn.focus();
  }

  function openPopup() {
    lastOpener = document.activeElement;
    renderCalendar();
    updateLabels();
    popup.getBoundingClientRect();
    popup.classList.add('is-open');
    popup.setAttribute('aria-hidden', 'false');
    getOpeners().forEach(function (el) { el.setAttribute('aria-expanded', 'true'); });
    closeBtn.focus();
  }

  function closePopup() {
    popup.classList.remove('is-open');
    popup.setAttribute('aria-hidden', 'true');
    getOpeners().forEach(function (el) { el.setAttribute('aria-expanded', 'false'); });
    // return focus to the opener only when closed from inside (Escape / close button)
    if (lastOpener && popup.contains(document.activeElement)) lastOpener.focus();
  }

  // Arrow/Home/End/PageUp/PageDown navigation (APG date picker). Enter/Space are native to the button.
  datesGrid.addEventListener('keydown', function (e) {
    const cell = e.target.closest('td[data-date]');
    if (!cell) return;
    const cur = fromIso(cell.dataset.date);
    const shiftDays = function (n) { return new Date(cur.getFullYear(), cur.getMonth(), cur.getDate() + n); };
    const shiftMonths = function (n) {
      const last = new Date(cur.getFullYear(), cur.getMonth() + n + 1, 0).getDate();
      return new Date(cur.getFullYear(), cur.getMonth() + n, Math.min(cur.getDate(), last));
    };

    let next;
    switch (e.key) {
      case 'ArrowRight': next = shiftDays(1); break;
      case 'ArrowLeft': next = shiftDays(-1); break;
      case 'ArrowDown': next = shiftDays(7); break;
      case 'ArrowUp': next = shiftDays(-7); break;
      case 'Home': next = shiftDays(-cur.getDay()); break;
      case 'End': next = shiftDays(6 - cur.getDay()); break;
      case 'PageUp': next = shiftMonths(-1); break;
      case 'PageDown': next = shiftMonths(1); break;
      default:
        // Prevent browser typeahead from jumping focus to the first matching cell.
        if (e.key.length === 1 && !e.ctrlKey && !e.metaKey && !e.altKey) e.preventDefault();
        return;
    }

    e.preventDefault();
    e.stopPropagation(); // cool-fse ada-menus also handles Home/End at document level
    focusDate(next);
  });

  datesBody.addEventListener('click', function (e) {
    const btn = e.target.closest('td[data-date] button:not(.past)');
    if (btn) selectDate(fromIso(btn.parentNode.dataset.date));
  });

  prevBtn.addEventListener('click', function () {
    if (viewYear === effectiveMin.getFullYear() && viewMonth === effectiveMin.getMonth()) return;
    viewMonth--;
    if (viewMonth < 0) { viewMonth = 11; viewYear--; }
    renderCalendar();
  });

  nextBtn.addEventListener('click', function () {
    viewMonth++;
    if (viewMonth > 11) { viewMonth = 0; viewYear++; }
    renderCalendar();
  });

  // No preventDefault + JS-built URL here — this is a real cross-domain GET
  // submission (rooms/adults come from the named selects, checkin/checkout
  // from the hidden inputs kept in sync above) so GA's linker, which decorates
  // <form> elements it finds already in the DOM, can pick it up.
  form.addEventListener('submit', function (e) {
    if (!checkin || !checkout) {
      e.preventDefault();
      alert('Please select a check-in and check-out date!');
    }
  });

  closeBtn.addEventListener('click', closePopup);

  popup.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') {
      closePopup();
      return;
    }
    // Tab trap — same first/last cycling as cool-fse ada-modal._handleTab
    if (e.key !== 'Tab') return;
    const focusable = popup.querySelectorAll('button:not([disabled]):not([tabindex="-1"]), select, [href]');
    const first = focusable[0];
    const last = focusable[focusable.length - 1];
    if (e.shiftKey && document.activeElement === first) {
      e.preventDefault();
      last.focus();
    } else if (!e.shiftKey && document.activeElement === last) {
      e.preventDefault();
      first.focus();
    }
  });

  // Event delegation — works regardless of when/where opener links are in the DOM
  document.addEventListener('click', function (e) {
    const opener = e.target.closest('a[href="#book-popup"]');
    if (opener) {
      e.preventDefault();
      popup.classList.contains('is-open') ? closePopup() : openPopup();
      return;
    }
    const path = e.composedPath();
    if (popup.classList.contains('is-open') && !path.includes(popup)) {
      closePopup();
    }
  });

  // Init opener aria attributes
  getOpeners().forEach(function (el) {
    el.setAttribute('aria-expanded', 'false');
    el.setAttribute('aria-controls', 'book-popup');
  });
});
